import { useSelection } from "@trydig/centra/client";

export const useCurrency = () =>
	useSelection({
		select: (data) => data.selection?.currency,
	});

export const useLocation = () => {
	return useSelection({
		select: (data) => data.location,
	});
};
